import { translations } from "./translations";

export {
  translations,
}



// WEBPACK FOOTER //
// ./locales/pl_PL/index.js